import Phaser from 'phaser'

// move this to a config file
const minimumPointerDistance = 40
const minAnimationPlayTime = 150


export default class Actor extends Phaser.Physics.Matter.Sprite {
  constructor({scene, x, y, texture, frame, options, stats}) {
    super(scene.matter.world, x, y, texture, frame, options)
    scene.add.existing(this)

    this.destination = {
      x: this.x,
      y: this.y
    }
    this.isPathFinding = false

    this.scene = scene
    this.stats = stats
    this.setFriction(.2)
    this.setFrictionAir(.2)
    this.setBounce(0)
    this.lastAnimationActionTime = 0
    this.lastFacing = 'Down'
    this.idleTime = 0
  }

  get isMoving () {
    return Math.abs(this.body.velocity.x) > 0
      || Math.abs(this.body.velocity.y) > 0
  }

  get facing() {
    let x = this.body.velocity.x
    let y = this.body.velocity.y
    if( (Math.abs(x) + 0.1) > Math.abs(y) ) {
      this.lastFacing = Math.sign(x) === 1
        ? 'Right' 
        : 'Left'
    } else {
      this.lastFacing = Math.sign(y) === 1
        ? 'Down' 
        : 'Up'
    }
    return this.lastFacing
  }

  get pointerDistance() {
    let pointer = this.scene.input.activePointer
    let camera = this.scene.cameras.main
    return Phaser.Math.Distance.Between(
      pointer.x + camera.scrollX,
      pointer.y + camera.scrollY,
      this.x,
      this.y
    )
  }

  moveToPointer () {
    let pointer = this.scene.input.activePointer
    let camera = this.scene.cameras.main
    this.moveTo(
      pointer.x + camera.scrollX,
      pointer.y + camera.scrollY,
    )
  }

  moveTo (x, y, isPathFinding=false) {
    this.isPathFinding = isPathFinding
    this.destination = { x, y }
  }

  stop(force=false) {

    if (this.isPathFinding && !force)
      return

    this.destination = {
      x: this.x,
      y: this.y
    }
    this.setVelocity(0)
  }

  //physics and other effects
  update({time, delta, pointer}) {
    super.update(time, delta)
    this.setVelocity(0)
    this.setAngularVelocity(0)
    let deltaLock = delta / 16.6

    let distance = Phaser.Math.Distance.Between(
      this.destination.x,
      this.destination.y,
      this.x,
      this.y
    )

    if (distance > 10) {
      let dx = this.destination.x - this.x
      let dy = this.destination.y - this.y
      let angle = Math.atan2(dy, dx)

      let vx = Math.cos(angle) * this.stats.speed * deltaLock
      let vy = Math.sin(angle) * this.stats.speed * deltaLock

      this.setVelocityX(vx)
      this.setVelocityY(vy)

    } else if (pointer.isDown && this.pointerDistance > minimumPointerDistance) {
      // continue moving if the player is just holding down the mouse
      // but do not let them jitter up mara
      this.moveToPointer()

    } else {
      this.stop(true)
    }
  }

  // graphics only changes
  preUpdate (time, delta) {
    super.preUpdate(time, delta)

    if (this.isMoving) {
      let movingAnimation = `run${this.facing}`
      if (this.anims.currentAnim.key != movingAnimation)
        this.play(movingAnimation, time)

    } else {
      this.idleTime += delta
      this.idle()
    }
  }

  idle() {
    if (this.idleTime > 100)
      super.play(`idle${this.lastFacing}`)
  }

  play(animationName, time=0) {
    // reduce jitter caused by "perfect" mouse placement
    if (Math.abs(time - this.lastAnimationActionTime) > minAnimationPlayTime) {
      super.play(animationName, true)
      this.lastAnimationActionTime = time
    }
    this.idleTime = 0
  }
}